import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "o-text-h2 mb-10" }
const _hoisted_2 = {
  key: "resetPasswordDescription",
  class: "mb-40"
}
const _hoisted_3 = {
  key: "userLoginForgotPasswordHelp",
  class: "mb-40"
}
const _hoisted_4 = { class: "inline-block mr-10" }
const _hoisted_5 = {
  key: 0,
  class: "mb-53"
}
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = { class: "c-magic-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link_conditional = _resolveComponent("router-link-conditional")!
  const _component_Recaptcha = _resolveComponent("Recaptcha")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_ConfirmationButton = _resolveComponent("ConfirmationButton")!
  const _component_Form = _resolveComponent("Form")!
  const _component_WebApiMessage = _resolveComponent("WebApiMessage")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "o-anim-fade-300",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("section", { key: _ctx.isResetPasswordState }, [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.isResetPasswordState ? _ctx.labels.resetPasswordTitle : _ctx.maybeRedirectTitle), 1),
        (_ctx.isResetPasswordState)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.labels.resetPasswordDescription), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.labels.createProfileDescriptionText), 1),
              _createVNode(_component_router_link_conditional, {
                class: "inline-block c-magic-line text-dusty-grey",
                to: _ctx.createProfileLink.url,
                "spa-enabled": _ctx.createProfileLink.spaLink,
                title: _ctx.labels.createProfileLinkText
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.labels.createProfileLinkText), 1)
                ]),
                _: 1
              }, 8, ["to", "spa-enabled", "title"])
            ])),
        _createVNode(_component_Form, { onSubmit: _ctx.verifyRecaptcha }, {
          default: _withCtx(({ handleSubmit }) => [
            _createVNode(_component_Recaptcha, {
              ref: "recaptcha",
              modelValue: _ctx.recaptchaKey,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recaptchaKey) = $event)),
              onVerify: ($event: any) => (handleSubmit(_ctx.submit))
            }, null, 8, ["modelValue", "onVerify"]),
            _createVNode(_Transition, {
              name: "o-anim-fade-300",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_ctx.isResetPasswordState && _ctx.showEmailSent)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.labels.resetPasswordEmailSentText), 1))
                  : (_openBlock(), _createBlock(_component_InputText, {
                      key: 1,
                      name: "username",
                      label: _ctx.labels.userNameInputPlaceholderLabel,
                      rules: "required|email",
                      type: "email",
                      autofocus: true,
                      autocomplete: "username"
                    }, null, 8, ["label"]))
              ]),
              _: 1
            }),
            (!_ctx.isResetPasswordState)
              ? (_openBlock(), _createBlock(_component_InputText, {
                  key: "password",
                  name: "password",
                  rules: "required",
                  label: _ctx.labels.passwordInputPlaceholderLabel,
                  type: "password",
                  autocomplete: "current-password",
                  "input-clear": false
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "flex flex-nowrap items-center text-dusty-grey",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {_ctx.toggleResetPasswordState();}, ["prevent"]))
              }, [
                (_ctx.isResetPasswordState)
                  ? (_openBlock(), _createBlock(_component_c_icon, {
                      key: 0,
                      name: "icon-arrow-small",
                      class: "rotate-180 h-8 mt-1 mr-3 xl:h-10 xl:mr-5 xl:-mt-1"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.isResetPasswordState ? _ctx.labels.backToLoginButtonText : _ctx.labels.forgotPasswordLinkTextLabel), 1)
              ]),
              _createVNode(_component_ConfirmationButton, {
                class: "min-w-200",
                confirm: _ctx.pending,
                text: _ctx.isResetPasswordState ? _ctx.labels.resetPasswordButtonText : _ctx.labels.loginBtnTextLabel,
                "confirmation-text": _ctx.isResetPasswordState ? _ctx.labels.resetPasswordButtonPendingText : _ctx.labels.loginBtnPendingTextLabel
              }, null, 8, ["confirm", "text", "confirmation-text"])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]),
        _createVNode(_component_WebApiMessage, {
          id: _ctx.loginFormWebApiMessageKey,
          "clear-timing": 3000,
          class: "mt-30"
        }, null, 8, ["id"])
      ]))
    ]),
    _: 1
  }))
}